export default {
  'meta': {
    'langName': 'LATVIAN',
    'lang': 'Latviešu'
  },
  'title': 'PRODUKTA ATSAUKUMS: BASKETBOLA GROZS B900 BOX NBA TARMAK',
  'description': 'Esam konstatējuši risku, ka basketbola groza B900 stabs var nokrist, ja tas tiek lietots bez regulēšanas roktura.\n\nJūsu drošības labad, nekavējoties pārtrauciet lietot grozu bez uzstādīta augstuma regulēšanas roktura.\n\nJūs varat to nostiprināt, sekojot vienkāršai procedūrai un izmantojot remonta komplektu, kas jums tiks piegādāts bez maksas.\n\nPašlaik tiek izstrādāta šim atsaukumam veltīta tīmekļa vietne. Tajā būs sniegti detalizēti norādījumi par nepieciešamo drošības darbu veikšanu.\n\nMēs jūs informēsim, tiklīdz tā būs pieejama (jūlija laikā).',
  'status': 'Translation validated by COUNTRY'
} as const
